import Card from './v1/index';

export default Card;
